/* eslint-env jquery */
const $ = jQuery.noConflict();

'use strict';
const StoreMap = {

	//initialize
	init: function() {
		if ($('.acf-map').length) {
			this.renderMap();
			this.polygon();
		}
	},

	//by clicking on the state, highlight the clicked state
	polygon: function() {
		function centerMap(map) {
			// Create map boundaries from all map markers.
			// eslint-disable-next-line no-undef
			const bounds = new google.maps.LatLngBounds();
			map.markers.forEach(function(marker){
				bounds.extend(marker.position);
			});
			// Case: Single marker.
			// eslint-disable-next-line eqeqeq
			if(map.markers.length === 1){
				map.setCenter(bounds.getCenter());
				// Case: Multiple markers.
			} else{
				map.fitBounds(bounds);
			}
		}

		$('.js-map__list-item').on('click', (e)=>{
			window.history.pushState(
				null,
				null,
				'?state=' + $(e.currentTarget).find('a').attr('data-state-short')
			);
			window.mapss.data.forEach(feature => {
				window.mapss.data.remove(feature);
			});
			$('.js-map__list-item').removeClass('active');
			$(e.currentTarget).addClass('active');
			const currentTarget = $(e.currentTarget);
			const currentState = $(currentTarget.find('a')).text();
			$.ajax({
				method: 'GET',
				url: 'https://nominatim.openstreetmap.org/search.php',
				data: {
					state: currentState,
					country: 'us',
					polygon_geojson: 1, //eslint-disable-line camelcase
					format: 'json'
				},
				success: (response) => {

					if(response.length === 0) {
						const map = window.mapp;
						centerMap(map);
						return false;
					}

					let geoJSONDataChunk = {
						geojson: {
							coordinates: [],
							type: ''
						},
						boundingbox: []
					};
					for(let i=0;i<response.length;i++){
						const element = response[i];
						const lat = element.lat;
						const lng = element.lon;
						const map = window.mapp;
						// eslint-disable-next-line
						const newLocation = new google.maps.LatLng(lat, lng);
						map.setCenter(newLocation);
						map.setZoom(5);
						if(element.geojson) {
							if(element.geojson.type) {
								if(element.geojson.type === 'MultiPolygon' || element.geojson.type === 'Polygon'){
									if(Array.isArray(element.geojson.coordinates[0])){
										geoJSONDataChunk = element;
										break;
									}
								}
							}
						}
					}
					const geoJSON = {
						'type': 'Feature',
						'geometry': geoJSONDataChunk.geojson,
						'properties': {
							'color': 'red',
							'SD_NAME': 'SD_NAME'
						},
					};
					window.mapss.data.addGeoJson(geoJSON, '');
					window.mapss.data.setStyle(function(feature) {
						const SD_NAME = feature.getProperty('SD_NAME');
						let color = '#118F8C';
						if (SD_NAME === 'SD_NAME') {
							color = '#D5D5C5';
						}
						return {
							fillColor: color,
							fillOpacity: 0.8,
							strokeWeight: 1,
							strokeColor: '#ff8000',
							strokeOpacity: 1,
						};
					});
				}, error: () => {
					const map = window.mapp;
					centerMap(map);
				}
			});
		});
	},

	renderMap: function() {
		function initMap($el) {
			// Find marker elements within map.
			const $markers = $el.find('.marker');
			const country = 'United States';

			// Create gerenic map.
			const mapArgs = {
				zoom: $el.data('zoom') || 16,
				// eslint-disable-next-line no-undef
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				styles: [
					{
						'featureType': 'administrative',
						'elementType': 'geometry.stroke',
						'stylers': [
							{
								'visibility': 'on'
							},
							{
								'gamma': '0.00'
							},
							{
								'color': '#f2f2f2'
							}
						]
					},
					{
						'featureType': 'administrative',
						'elementType': 'labels',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'administrative.country',
						'elementType': 'geometry.stroke',
						'stylers': [
							{
								'visibility': 'on'
							},
							{
								'gamma': '6.74'
							},
							{
								'lightness': '80'
							}
						]
					},
					{
						'featureType': 'administrative.province',
						'elementType': 'all',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'administrative.province',
						'elementType': 'geometry.stroke',
						'stylers': [
							{
								'visibility': 'on'
							},
							{
								'gamma': '1'
							},
							{
								'color': '#FF8000'
							}
						]
					},
					{
						'featureType': 'administrative.locality',
						'elementType': 'all',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'administrative.neighborhood',
						'elementType': 'all',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'administrative.land_parcel',
						'elementType': 'all',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'landscape',
						'elementType': 'all',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'landscape',
						'elementType': 'geometry',
						'stylers': [
							{
								'visibility': 'on'
							},
							{
								'color': '#f2f2f2'
							}
						]
					},
					{
						'featureType': 'landscape.man_made',
						'elementType': 'labels',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'landscape.natural',
						'elementType': 'labels',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'landscape.natural.terrain',
						'elementType': 'all',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'poi',
						'elementType': 'all',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'poi.attraction',
						'elementType': 'all',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'road',
						'elementType': 'all',
						'stylers': [
							{
								'color': '#f2f2f2'
							},
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'road',
						'elementType': 'labels',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'road.highway',
						'elementType': 'all',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'transit',
						'elementType': 'all',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'transit',
						'elementType': 'labels.icon',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'transit.line',
						'elementType': 'geometry',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'transit.line',
						'elementType': 'labels.text',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'transit.station',
						'elementType': 'all',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'transit.station.airport',
						'elementType': 'geometry',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'transit.station.airport',
						'elementType': 'labels',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					},
					{
						'featureType': 'water',
						'elementType': 'geometry',
						'stylers': [
							{
								'color': '#d1e2e5'
							}
						]
					},
					{
						'featureType': 'water',
						'elementType': 'labels',
						'stylers': [
							{
								'visibility': 'off'
							}
						]
					}
				]
			};
			// eslint-disable-next-line no-undef
			const map = new google.maps.Map($el[0], mapArgs);
			window['mapss'] = map;
			// eslint-disable-next-line no-undef
			const geocoder = new google.maps.Geocoder();
			window['geocoderr'] = geocoder;

			geocoder.geocode({'address': country}, function(results, status) {
				// eslint-disable-next-line no-undef
				if (status === google.maps.GeocoderStatus.OK) {
					map.setZoom(5);
				} else {
					alert('Could not find location: ' + location);
				}
			});

			// Add markers.
			map.markers = [];
			$markers.each(function(){
				initMarker($(this), map);
				window['mapp'] = map;
			});

			// Center map based on markers.
			centerMap(map);

			// Return map instance.
			return map;
		}

		/**
		 * initMarker
		 *
		 * Creates a marker for the given jQuery element and map.
		 *
		 * @date    22/10/19
		 * @since   5.8.6
		 *
		 * @return  object The marker instance.
		 * @param $marker
		 * @param map
		 */
		function initMarker($marker, map) {
			// Get position from marker.
			const lat = $marker.data('lat');
			const lng = $marker.data('lng');
			const latLng = {
				lat: parseFloat(lat),
				lng: parseFloat(lng),
			};
			// eslint-disable-next-line no-undef
			const marker = new google.maps.Marker({
				position: latLng,
				map: map,
				// eslint-disable-next-line no-undef
				icon: northpoint_map.site_url + '/wp-content/themes/fws-northpoint/src/assets/images/pin-black.webp' //eslint-disable-line camelcase
			});

			// Append to reference for later use.
			map.markers.push(marker);

			// If marker contains HTML, add it to an infoWindow.
			if($marker.html()){
				// Create info window.
				// eslint-disable-next-line no-undef
				const infowindow = new google.maps.InfoWindow({
					content: $marker.html()
				});

				// Show info window when marker is clicked.
				// eslint-disable-next-line no-undef
				google.maps.event.addListener(marker, 'click', function() {
					infowindow.open(map, marker);
				});
				marker.addListener('click', () => {
					// eslint-disable-next-line no-undef
					marker.setIcon(northpoint_map.site_url + '/wp-content/themes/fws-northpoint/src/assets/images/pin-active.webp'); //eslint-disable-line camelcase
					setTimeout(()=>{
						const clickedPins = $('.acf-map').find('.js-popup-small__title');
						clickedPins.each((index, value)=>{
							const clickedPin = $(value).text();
							// dispatch request
							$.ajax({
								url: window.fwsLocalized.ajaxUrl,
								type: 'POST',
								data: {
									action: 'pin',
									pin: clickedPin,
								},
							});
						});
					});
				});

				// eslint-disable-next-line no-undef
				infowindow.addListener('closeclick', ()=>{
					// eslint-disable-next-line no-undef
					marker.setIcon(northpoint_map.site_url + '/wp-content/themes/fws-northpoint/src/assets/images/pin-black.webp'); //eslint-disable-line camelcase
				});
			}


		}

		/**
		 * centerMap
		 *
		 * Centers the map showing all markers in view.
		 *
		 * @date    22/10/19
		 * @since   5.8.6
		 *
		 * @return  void
		 * @param map
		 */
		function centerMap(map) {

			// Create map boundaries from all map markers.
			// eslint-disable-next-line no-undef
			const bounds = new google.maps.LatLngBounds();
			map.markers.forEach(function(marker){
				bounds.extend(marker.position);
			});
			// Case: Single marker.
			// eslint-disable-next-line eqeqeq
			if(map.markers.length === 1){
				map.setCenter(bounds.getCenter());
				// Case: Multiple markers.
			} else{
				map.fitBounds(bounds);
			}
		}

		// Render maps on page load.
		$(document).ready(function(){
			$('.acf-map').each(function(){
				// eslint-disable-next-line no-unused-vars
				const map = initMap($(this));
				$('.js-map__list-item').each((index, value)=>{
					const linkValue = $(value).find('a').attr('data-state-short');
					if (window.location.href.indexOf(linkValue) > -1) {
						setTimeout(()=>{
							$(value).trigger('click');
						}, 500);
					}
				});
			});
		});

	}

};

export default StoreMap;
